/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentNotification {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentNotification.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentNotification>): WellArchitectedFrameworkAssessmentNotification {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentNotification(), model);
        WellArchitectedFrameworkAssessmentNotification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentNotification>): WellArchitectedFrameworkAssessmentNotification {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentNotification.newInstance(<WellArchitectedFrameworkAssessmentNotification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentNotification) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentNotification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentNotification): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentNotification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.webhooks) {
            for (let val of this.webhooks) {
                models.WellArchitectedFrameworkAssessmentNotificationWebHook.fixupPrototype(val);
            }
        }
    }

    email_recipients: Array<string>;

    /**
     * webhooks to trigger notifications
     */
    webhooks: Array<models.WellArchitectedFrameworkAssessmentNotificationWebHook>;

}
